module.exports = __webpack_public_path__ + "static/media/NitheshPadival.0bdb20ea.svg";